import bigInt from "big-integer";

export const TOTAL_REWARD_AMOUNT = 10000000;

export const BUY_LINK = {
  "0xdADc4F8E9d8d37294de0E02A2Ce8Cc0c90A4F6c2":
    "https://app.uniswap.org/swap?inputCurrency=ETH&outputCurrency=0xdADc4F8E9d8d37294de0E02A2Ce8Cc0c90A4F6c2",
  "0x3B6a33fE7Cc7dd0D53E9a16e92aB5db3E54fdcf7":
    "https://app.uniswap.org/add/v2/ETH/0xdADc4F8E9d8d37294de0E02A2Ce8Cc0c90A4F6c2",
  "0x6eB0f4B90EeB237f6ee6d5D8d69C15810b81fa05":
    "https://aerodrome.finance/liquidity?filter=default&query=vAMM-WETH%2FBUIDL"
};

export const FORMAT_APY = (apy) => {
  if (apy > 1000000000) {
    return `${parseInt(String(apy / 1000000000)).toLocaleString()} B`;
  }
  return parseInt(String(apy)).toLocaleString();
};

export const expandFixed = (value, decimals = 18) => {
  const valueStr = value.toString();
  const parts = valueStr.split(".");

  const integerPart = parts[0];
  let decimalPart = parts[1] || "";

  if (decimalPart.length > decimals) {
    decimalPart = decimalPart.substring(0, decimals);
  }
  while (decimalPart.length < decimals) {
    decimalPart += "0";
  }

  const combinedValue = bigInt(integerPart + decimalPart);

  if (!parts[1]) {
    return bigInt(integerPart).multiply(bigInt(10).pow(decimals));
  }

  return combinedValue;
};

export const BUIDL_USDC_POOL_ADDRESS =
  "0xb3BC23ceD4fae30152870012d659267CEcaedD35";
export const BUIDL_ETH_POOL_ADDRESS =
  "0xF3A0d1c8b4fcF19dFdFacE59263Fc40a18d792a6";
export const BUIDL_WETH_AERO_POOL_ADDRESS =
  "0x6eB0f4B90EeB237f6ee6d5D8d69C15810b81fa05";
